import React, { ReactElement } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Playground from './content/Playground';
import Home from './content/Home';

// async function loadPreline() {
//   return import('preline/dist/index.js');
// }

const LayoutShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // const location = useLocation();

  // React.useEffect(() => {
  //     const initPreline = async () => {
  //     await loadPreline();

  //     if (
  //         window.HSStaticMethods &&
  //         typeof window.HSStaticMethods.autoInit === 'function'
  //     ) {
  //         window.HSStaticMethods.autoInit();
  //     }
  //     };

  //     initPreline();
  // }, [location.pathname]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

function App(): ReactElement {
  // if (!GlobalVariables.authenticated) {
  //     return (
  //         <BrowserRouter>
  //             <Routes>
  //                 <Route path="*" element={<Login />} />
  //             </Routes>
  //         </BrowserRouter>
  //     );
  // }

  return (
    <BrowserRouter>
      <LayoutShell>
        <Routes>
          <Route path="*" element={<Home />} />
          <Route path="/playground" element={<Playground />} />
        </Routes>
        <div className="z-50 w-60 min-w-60 p-0.5 fixed top-[10px] right-[-90px] text-xs text-white font-bold bg-red-600 rotate-45 text-center">
          Closed
          <br />
          BETA
        </div>
      </LayoutShell>
    </BrowserRouter>
  );
}

export default App;
